export default __webpack_public_path__ + "static/media/croptop-medium-right.9c0e3970.jpg";